import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import CTASection from "../components/CTASection";

export default function Services() {
  const { lang, t } = useLang();
  const p = t.pages.services;

  return (
    <div data-testid="services-page">
      <PageHeader
        overline={p.overline}
        title={p.titleA}
        accent={p.accent}
        subtitle={p.subtitle}
      />

      <section className="pb-24 sm:pb-32 bg-navy">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 space-y-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title.en} delay={0.04 * i}>
                <div
                  data-testid={`service-detail-${i}`}
                  className="group grid grid-cols-1 md:grid-cols-12 gap-8 items-center bg-deepblack border border-gold/20 p-8 sm:p-10 hover:border-gold/50 transition-colors duration-300"
                >
                  <div className="md:col-span-1 flex md:block items-center gap-4">
                    <span className="font-serif text-5xl text-gold/30 group-hover:text-gold/60 transition-colors">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="md:col-span-2">
                    <div className="h-14 w-14 flex items-center justify-center border border-gold/30 text-gold group-hover:bg-gold group-hover:text-deepblack transition-colors duration-300">
                      <Icon size={26} />
                    </div>
                  </div>
                  <div className="md:col-span-9">
                    <h3 className="font-serif text-3xl text-offwhite mb-3">
                      {s.title[lang]}
                    </h3>
                    <p className="text-muted2 leading-relaxed">{s.detail[lang]}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}

          <Reveal className="text-center pt-10">
            <Link
              to="/contact"
              data-testid="services-cta"
              className="inline-flex items-center gap-2 bg-gold text-deepblack px-9 py-4 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-goldhover transition-colors"
            >
              {p.cta} <ArrowRight size={15} />
            </Link>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
